export const SLIDER_DEFAULT_VALUE = 5.5;

export const MAX_GOALS_PER_DOMAIN = 3;
